import React, { memo } from 'react';
import { useNotifications } from '../context/NotificationContext';

const BellNotification = memo(({ className = '' }) => {
  const { bellCount, openModal, lastUpdate } = useNotifications();

  const handleBellClick = (e) => {
    e.preventDefault();
    openModal();
  };

  // Classe de animação baseada no timestamp
  const animationClass = bellCount > 0 ? `shake-animation-${lastUpdate % 1000}` : '';
  const finalClassName = `${className} ${animationClass}`.trim();

  return (
    <li className={finalClassName}>
      <a
        href="#"
        id="notifications"
        className="dropdown-toggle a_button"
        data-toggle="modal"
        onClick={handleBellClick}
      >
        <div style={{ position: 'relative', display: 'inline-block' }}>
          <i
            className="fa fa-bell"
            style={{
              animation: bellCount > 0 ? 'shake 1.5s ease-in-out infinite' : 'none',
            }}
          />
          {bellCount > 0 && (
            <span
              style={{
                position: 'absolute',
                top: '-10px',
                right: '-10px',
                backgroundColor: 'red',
                color: 'white',
                borderRadius: '50%',
                padding: '2px 6px',
                fontSize: '12px',
                fontWeight: 'bold',
                minWidth: '18px',
                textAlign: 'center'
              }}
            >
              {bellCount}
            </span>
          )}
        </div>
      </a>
    </li>
  );
});

BellNotification.displayName = 'BellNotification';

export default BellNotification;